import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, forwardRef, useCallback, useEffect, useRef, useState } from 'react';
import { BKJComboBoxAsync } from '../BKJComboBoxAsync/index.js';
import { normalizedPlaceHandleChange } from './normalizedPlaceChangeHandler.js';
function createGQLDataContext(initialState) {
    return createContext({
        ...(initialState || {}),
        status: 'LOADING',
        __typename: 'GraphQLAPI',
    });
}
const Component = forwardRef((props, ref) => {
    const { className, label, name = '', placeholder, required, disabled, error, onChange, value, searchValue, css, ...rest } = props;
    return (_jsx(BKJComboBoxAsync, { ...rest, css: css, searchValue: searchValue, searchKey: "addressSearch", ref: ref, context: BKJAddressInputDataContext, className: className, label: label, name: name, placeholder: placeholder, required: required, disabled: disabled, error: error, onChange: onChange, value: value, action: "ClearInputValue", overrides: ['NoInitialResults'] }));
});
export const BKJAddressInputDataContext = createGQLDataContext({
    pageInfo: { hasNextPage: false },
});
export const BKJAddressInputDataProvider = ({ onChange, ...props }) => {
    const inputRef = useRef(null);
    const timeoutRef = useRef(null);
    const [status, setStatus] = useState('READY');
    const [results, setResults] = useState([]);
    const [selected, setSelected] = useState({
        id: props.value,
        value: props.value,
        label: props.value,
        type: 'Standard',
    });
    const [searchValue, setSearchValue] = useState('');
    const handleFetch = useCallback((value) => {
        const searchService = new window.google.maps.places.AutocompleteService(document.createElement('div'));
        setStatus('LOADING');
        searchService.getQueryPredictions({
            input: value,
        }, (results) => {
            const nextResults = !!results
                ? results.map((result) => {
                    console.log(result);
                    return {
                        id: result.place_id,
                        value: result.description,
                        label: result.description,
                        type: 'Standard',
                    };
                })
                : [];
            setResults(nextResults);
            setStatus('READY');
        });
    }, []);
    const handleSearchChange = useCallback((event) => {
        setSearchValue(event.target.value);
        if (timeoutRef.current)
            window.clearTimeout(timeoutRef.current);
        if (!event.target.value)
            return;
        timeoutRef.current = window.setTimeout(() => {
            handleFetch(event.target.value);
        }, 500);
    }, [handleFetch]);
    const selectPlace = useCallback((result) => {
        if (typeof result?.id === 'undefined')
            return;
        const geoService = new window.google.maps.Geocoder();
        const geoSearchAddress = result.value;
        geoService.geocode({ address: geoSearchAddress }, (arg2) => {
            if (arg2) {
                arg2.forEach((geoResult) => {
                    const { geometry, address_components, formatted_address } = geoResult;
                    const nextState = [
                        {
                            target: {
                                value: result.value,
                                name: props.name,
                            },
                        },
                        ...normalizedPlaceHandleChange({
                            formatted_address,
                            geometry,
                            address_components,
                        }),
                    ];
                    setSelected(result);
                    if (onChange)
                        onChange(nextState);
                    setSearchValue(formatted_address);
                    setStatus('READY');
                });
            }
        });
    }, [props]);
    const handleChange = useCallback((event) => {
        selectPlace(event.target.value);
    }, [selectPlace]);
    useEffect(() => {
        if (props.value)
            handleFetch(props.value);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return (_jsx(BKJAddressInputDataContext.Provider, { value: {
            ...BKJAddressInputDataContext,
            status,
            isLoading: status === 'LOADING',
            data: results,
            options: results,
            pageInfo: {
                hasNextPage: false,
            },
            fetch: handleFetch,
            __typename: 'GraphQLAPI',
        }, children: _jsx(Component, { ...props, action: "OpenToggle", type: "Single", label: props.label, options: results, name: props.name, searchValue: searchValue, ref: inputRef, value: selected, onSearchChange: handleSearchChange, onChange: handleChange, className: props.className, css: props.css }) }));
};
//# sourceMappingURL=BKJAddressInput.context.js.map